import axios from 'axios';
import { RequestHandler } from 'festo-react-ui-kit';
import { Filter } from './interfaces';

export const getFilters = async () => {
  const { language, country, applicationType } = new RequestHandler();

  const translationOrder = applicationType === 'standalone' ? `${country}_${language}` : `${language}_${country}`;

  const url = `/eac/${translationOrder}/flowrate-calculation-backend/filter-configuration`;

  const options = {
    headers: {
      'Content-Type': `application/json`,
    },
  };

  const response = await axios.get<Filter[]>(url, options);

  return response;
};
